import axios from "axios";

const baseURL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api";

export const axiosInstance = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Attach Authorization header from localStorage if present
axiosInstance.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("token") || localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Simple response interceptor for logging / centralized error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // You can add global error handling or token refresh logic here
    // console.error("API error:", error);
    return Promise.reject(error);
  }
);

export default axiosInstance;